import { Flex, Heading, IconButton } from '@chakra-ui/react';
import { CustomSlideIndex } from '@llx/common';
import { useState } from 'react';
import { MdArrowBackIos } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';

import { useLoggedInUserAuthContext } from '@/components/AuthTokenContextProvider/UserAuthContext';
import CaseExplorerClient from '@/components/CaseExplorer/CaseExplorerClient';
import CaseDisclaimerView from '@/components/disclaimer/CaseDisclaimerView';
import { useCurrentMeetingDataContext } from '@/features/meeting/context/CurrentMeetingDataContext';
import useShowDisclaimer from '@/hooks/useShowDisclaimer';
import { ROUTES } from '@/routes/Routes';
import PageLayout from '@/ui/Layout/PageLayout';
import { TimerLoader } from '@/ui-components/TimerLoader/TimerLoader';

import CaseSlideNavigator from '../caseCluster/CaseSlideNavigator';

export default function CaseView() {
  const { currentCase } = useCurrentMeetingDataContext();
  const [slideIndex, setSlideIndex] = useState<number>(0);
  const { isAdmin } = useLoggedInUserAuthContext();
  const { showDisclaimer, startedAt, endsAt } = useShowDisclaimer({
    currentCase: currentCase,
    isNPSScorePage: false,
  });
  const navigate = useNavigate();
  const isNPSScorePage: boolean = slideIndex === CustomSlideIndex.NPS_SCORE || false;
  const isAllowedToNavigate =
    currentCase && (!currentCase?.disclaimer || !showDisclaimer) && !isNPSScorePage;

  return (
    <PageLayout showHeader={false} showFooter={false}>
      <Flex
        alignItems="center"
        background="white"
        boxShadow="0px 2px 10px #f4f4f4"
        padding="5px"
        zIndex={1}
      >
        {isAdmin && (
          <IconButton
            rounded="100%"
            aria-label="back-button"
            pl="5px"
            icon={<MdArrowBackIos fontSize="20px" />}
            onClick={() => navigate(`${ROUTES.ADMIN_CASE_LIST}`, { replace: true })}
          />
        )}
        <Heading fontSize="15px" pl="20px" color="livelinx.grey200">
          {currentCase?.displayName}
        </Heading>
      </Flex>
      {currentCase?.id && currentCase && (
        <Flex h="100%" w="100%" direction="column">
          {currentCase.disclaimer && !!showDisclaimer ? (
            <CaseDisclaimerView disclaimer={currentCase.disclaimer} casePath={currentCase.path} />
          ) : (
            <CaseExplorerClient
              patientCaseIndex={0}
              patientCase={currentCase}
              isHost={true}
              forcedCurrSlide={currentCase?.slides?.[slideIndex]}
            />
          )}
          {currentCase.disclaimer && showDisclaimer && (
            <TimerLoader startedAt={startedAt} endsAt={endsAt} />
          )}
          <Flex
            height="68px"
            width="100%"
            maxW="100%"
            overflow="hidden"
            backgroundColor="livelinx.purple75"
            justifyContent="space-between"
            boxShadow="1px -1px 5px 5px #5e00f611"
            gap="10px"
            pl="5px"
          >
            {isAllowedToNavigate && (
              <CaseSlideNavigator
                currentSlideIdx={slideIndex}
                slides={currentCase.slides || []}
                onSlideChange={(slide) => {
                  setSlideIndex(slide);
                }}
                onHomeClick={() => {
                  console.log('here!');
                }}
              />
            )}
          </Flex>
        </Flex>
      )}
    </PageLayout>
  );
}
